document.documentElement.classList.remove('no-js');

(function () {
  const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
    ? window.Shopify.routes.root
    : '/';

  const drawer = document.querySelector('[data-cart-drawer]');
  const overlay = document.querySelector('[data-cart-overlay]');
  const toast = document.querySelector('[data-cart-toast]');

  function formatMoney(cents) {
    const currency = drawer?.dataset.currency || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EGP';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: currency,
        maximumFractionDigits: 2
      }).format((Number(cents) || 0) / 100);
    } catch (e) {
      return `${((Number(cents) || 0) / 100).toFixed(2)} ${currency}`;
    }
  }

  function escapeHtml(value) {
    const div = document.createElement('div');
    div.textContent = value == null ? '' : String(value);
    return div.innerHTML;
  }

  function showToast(message, isError) {
    if (!toast) return;
    toast.textContent = message;
    toast.classList.toggle('is-error', Boolean(isError));
    toast.classList.add('is-visible');
    window.clearTimeout(showToast._timer);
    showToast._timer = window.setTimeout(() => toast.classList.remove('is-visible'), 2600);
  }

  function openDrawer() {
    if (!drawer || !overlay) return;
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('dm-cart-open');
  }

  function closeDrawer() {
    if (!drawer || !overlay) return;
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('dm-cart-open');
  }

  async function getCart() {
    const response = await fetch(`${root}cart.js`, {
      headers: { Accept: 'application/json' }
    });
    if (!response.ok) throw new Error('Could not load cart');
    return response.json();
  }

  function renderCart(cart) {
    document.querySelectorAll('[data-cart-count], [data-cart-drawer-count]').forEach((el) => {
      el.textContent = cart.item_count;
    });

    const subtotal = document.querySelector('[data-cart-subtotal]');
    if (subtotal) subtotal.textContent = formatMoney(cart.total_price);

    const container = document.querySelector('[data-cart-drawer-items]');
    if (!container) return;

    if (!cart.items.length) {
      container.innerHTML = `
        <div class="dm-cart-empty">
          <div class="dm-cart-empty__icon">◎</div>
          <h3>Your bag is empty</h3>
          <p>Add products and keep shopping — they will stay here.</p>
          <button class="dm-btn" type="button" data-cart-close>Continue shopping</button>
        </div>`;
      return;
    }

    container.innerHTML = cart.items.map((item, index) => {
      const image = item.image
        ? `<img src="${escapeHtml(item.image)}&width=180" alt="${escapeHtml(item.product_title)}" loading="lazy">`
        : '<div class="dm-cart-line__placeholder"></div>';
      const variant = item.variant_title && item.variant_title !== 'Default Title'
        ? `<div class="dm-cart-line__variant">${escapeHtml(item.variant_title)}</div>`
        : '';
      return `
        <article class="dm-cart-line" data-cart-line="${index + 1}">
          <a class="dm-cart-line__image" href="${escapeHtml(item.url)}">${image}</a>
          <div class="dm-cart-line__info">
            <a class="dm-cart-line__title" href="${escapeHtml(item.url)}">${escapeHtml(item.product_title)}</a>
            ${variant}
            <div class="dm-cart-line__price">${formatMoney(item.final_line_price)}</div>
            <div class="dm-cart-line__controls">
              <button type="button" data-cart-qty="minus" data-line="${index + 1}" aria-label="Decrease quantity">−</button>
              <span>${item.quantity}</span>
              <button type="button" data-cart-qty="plus" data-line="${index + 1}" aria-label="Increase quantity">+</button>
              <button class="dm-cart-line__remove" type="button" data-cart-remove data-line="${index + 1}">Remove</button>
            </div>
          </div>
        </article>`;
    }).join('');
  }

  async function refreshCart(shouldOpen) {
    const cart = await getCart();
    renderCart(cart);
    if (shouldOpen) openDrawer();
    return cart;
  }

  async function changeCart(line, quantity) {
    if (!drawer) return;
    const url = drawer.dataset.cartChangeUrl || `${root}cart/change`;
    const response = await fetch(`${url}.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ line: Number(line), quantity: Number(quantity) })
    });
    if (!response.ok) throw new Error('Could not update cart');
    const cart = await response.json();
    renderCart(cart);
  }

  document.addEventListener('click', async function (event) {
    const toggle = event.target.closest('[data-mobile-toggle]');
    if (toggle) {
      const menu = document.querySelector('[data-mobile-menu]');
      if (menu) menu.classList.toggle('is-open');
      return;
    }

    if (event.target.closest('[data-cart-open]')) {
      event.preventDefault();
      try {
        await refreshCart(true);
      } catch (error) {
        openDrawer();
      }
      return;
    }

    if (event.target.closest('[data-cart-close]') || event.target.closest('[data-cart-overlay]')) {
      closeDrawer();
      return;
    }

    const qtyButton = event.target.closest('[data-cart-qty]');
    if (qtyButton) {
      const lineEl = qtyButton.closest('[data-cart-line]');
      const current = Number(lineEl?.querySelector('.dm-cart-line__controls span')?.textContent || 1);
      const next = qtyButton.dataset.cartQty === 'plus' ? current + 1 : Math.max(0, current - 1);
      qtyButton.disabled = true;
      try {
        await changeCart(qtyButton.dataset.line, next);
      } catch (error) {
        showToast('Could not update your cart.', true);
      }
      return;
    }

    const removeButton = event.target.closest('[data-cart-remove]');
    if (removeButton) {
      removeButton.disabled = true;
      try {
        await changeCart(removeButton.dataset.line, 0);
      } catch (error) {
        showToast('Could not remove this item.', true);
      }
      return;
    }

    const filterToggle = event.target.closest('[data-filter-toggle]');
    if (filterToggle) {
      const sidebar = document.querySelector('[data-filter-sidebar]');
      if (sidebar) sidebar.classList.toggle('is-open');
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeDrawer();
  });

  document.addEventListener('submit', async function (event) {
    const form = event.target.closest('[data-ajax-cart-form], .dm-product-form');
    if (!form) return;
    if (form.classList.contains('dm-product-form')) return;

    event.preventDefault();

    const button = form.querySelector('[type="submit"]');
    const label = button?.querySelector('[data-add-label]');
    const originalLabel = label?.textContent || button?.textContent || 'Add to cart';

    if (button) button.disabled = true;
    if (label) label.textContent = 'Adding…';

    try {
      const addUrl = drawer?.dataset.cartAddUrl || `${root}cart/add`;
      const response = await fetch(`${addUrl}.js`, {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'application/json' }
      });

      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || 'Could not add item');

      await refreshCart(true);
      showToast('Added to your bag ✓');
      if (label) label.textContent = 'Added ✓';
      window.setTimeout(() => {
        if (label) label.textContent = originalLabel;
      }, 1300);
    } catch (error) {
      showToast(error.message || 'Could not add this item.', true);
      if (label) label.textContent = originalLabel;
    } finally {
      if (button) button.disabled = false;
    }
  });

  function resolveSwatchColor(name) {
    const raw = String(name || '').trim();
    const key = raw.toLowerCase().replace(/[_-]+/g, ' ').replace(/\s+/g, ' ').trim();

    const colors = {
      'black':'#0b0d10','jet black':'#050607','أسود':'#0b0d10','اسود':'#0b0d10',
      'white':'#f7f7f5','off white':'#eee9df','off-white':'#eee9df','cream':'#f3ead3','أبيض':'#f7f7f5','ابيض':'#f7f7f5','اوف وايت':'#eee9df',
      'red':'#d92e38','dark red':'#7f1720','maroon':'#6d1f2c','burgundy':'#6b1f33','أحمر':'#d92e38','احمر':'#d92e38','نبيتي':'#6b1f33',
      'blue':'#2478d4','navy':'#14284f','navy blue':'#14284f','royal blue':'#2c4fbd','sky blue':'#71bce8','baby blue':'#92cceb','cyan':'#19bfff','أزرق':'#2478d4','ازرق':'#2478d4','كحلي':'#14284f','لبني':'#92cceb',
      'green':'#2f8d4e','dark green':'#1f5137','olive':'#72773a','mint':'#8ed8bb','lime':'#8fcf3a','أخضر':'#2f8d4e','اخضر':'#2f8d4e','زيتي':'#72773a',
      'grey':'#7d858d','gray':'#7d858d','dark grey':'#3f464d','dark gray':'#3f464d','charcoal':'#333b42','silver':'#b9bec4','رمادي':'#7d858d','رصاصي':'#7d858d','فحمي':'#333b42','فضي':'#b9bec4',
      'yellow':'#f0c62e','gold':'#d8ad35','mustard':'#c99a24','أصفر':'#f0c62e','اصفر':'#f0c62e','ذهبي':'#d8ad35',
      'orange':'#ef7f2d','برتقالي':'#ef7f2d',
      'purple':'#7653bd','violet':'#7045a7','lavender':'#a78bd7','موف':'#7653bd','بنفسجي':'#7653bd',
      'pink':'#e76b9b','hot pink':'#e7448d','rose':'#cc6f7b','وردي':'#e76b9b','بينك':'#e76b9b',
      'brown':'#79543e','tan':'#b58a65','beige':'#d3bea1','khaki':'#b6aa7a','بني':'#79543e','بيج':'#d3bea1','كاكي':'#b6aa7a',
      'teal':'#168b8b','turquoise':'#2db9b0','تركواز':'#2db9b0',
      'multi':'conic-gradient(#19bfff,#e7448d,#f0c62e,#2f8d4e,#19bfff)',
      'multicolor':'conic-gradient(#19bfff,#e7448d,#f0c62e,#2f8d4e,#19bfff)','multi color':'conic-gradient(#19bfff,#e7448d,#f0c62e,#2f8d4e,#19bfff)','متعدد':'conic-gradient(#19bfff,#e7448d,#f0c62e,#2f8d4e,#19bfff)'
    };

    if (colors[key]) return colors[key];
    if (/^#([0-9a-f]{3}|[0-9a-f]{6}|[0-9a-f]{8})$/i.test(raw)) return raw;

    if (window.CSS && CSS.supports && CSS.supports('color', raw)) return raw;
    return '#6f7781';
  }

  function isLightSwatch(color) {
    if (!color || color.indexOf('gradient') !== -1 || color[0] !== '#') return false;
    let hex = color.slice(1);
    if (hex.length === 3) hex = hex.split('').map((c) => c + c).join('');
    if (hex.length < 6) return false;
    const r = parseInt(hex.slice(0, 2), 16);
    const g = parseInt(hex.slice(2, 4), 16);
    const b = parseInt(hex.slice(4, 6), 16);
    return ((r * 299 + g * 587 + b * 114) / 1000) > 185;
  }

  function initProductSection(section) {
    const variantsScript = section.querySelector('[data-product-variants]');
    const variantInput = section.querySelector('[data-variant-id]');
    const optionSelects = Array.from(section.querySelectorAll('[data-product-option]'));
    const colorSwatches = Array.from(section.querySelectorAll('[data-color-swatch]'));
    const selectedOptionLabels = Array.from(section.querySelectorAll('[data-selected-option-value]'));
    const priceNode = section.querySelector('[data-product-price]');
    const submitButton = section.querySelector('.dm-product-form__submit');
    const addLabel = section.querySelector('[data-add-label]');
    const mainImage = section.querySelector('[data-product-main-image]');
    const thumbs = Array.from(section.querySelectorAll('[data-product-thumb]'));

    let variants = [];
    if (variantsScript) {
      try {
        variants = JSON.parse(variantsScript.textContent || '[]');
      } catch (error) {
        variants = [];
      }
    }

    function setMainImage(src, alt, mediaId) {
      if (!mainImage || !src) return;
      mainImage.classList.add('is-switching');
      const next = new Image();
      next.onload = function () {
        mainImage.src = src;
        mainImage.removeAttribute('srcset');
        mainImage.alt = alt || mainImage.alt || '';
        mainImage.classList.remove('is-switching');
      };
      next.onerror = function () {
        mainImage.classList.remove('is-switching');
      };
      next.src = src;

      thumbs.forEach((thumb) => {
        thumb.classList.toggle('is-active', mediaId && String(thumb.dataset.mediaId) === String(mediaId));
      });
    }

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', function () {
        setMainImage(this.dataset.mediaSrc, this.dataset.mediaAlt, this.dataset.mediaId);
      });
    });

    colorSwatches.forEach((swatch) => {
      const chip = swatch.querySelector('[data-color-chip]');
      const color = resolveSwatchColor(swatch.dataset.value || chip?.dataset.colorName || '');
      if (chip) {
        chip.style.setProperty('--dm-swatch', color);
        chip.style.background = color;
        chip.style.setProperty('--dm-swatch-check', isLightSwatch(color) ? '#061019' : '#ffffff');
      }

      swatch.addEventListener('click', function () {
        const position = this.dataset.optionPosition;
        const select = section.querySelector(`[data-product-option][data-option-position="${position}"]`);
        if (!select) return;
        select.value = this.dataset.value || '';
        select.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    function syncColorSwatches() {
      colorSwatches.forEach((swatch) => {
        const position = swatch.dataset.optionPosition;
        const select = section.querySelector(`[data-product-option][data-option-position="${position}"]`);
        const selected = !!select && select.value === swatch.dataset.value;
        swatch.classList.toggle('is-selected', selected);
        swatch.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });

      selectedOptionLabels.forEach((label) => {
        const select = section.querySelector(`[data-product-option][data-option-position="${label.dataset.selectedOptionValue}"]`);
        if (select) label.textContent = select.value;
      });
    }

    syncColorSwatches();

    if (!optionSelects.length || !variants.length || !variantInput) return;

    function selectedValues() {
      return optionSelects.map((select) => select.value);
    }

    function findVariant() {
      const values = selectedValues();
      return variants.find((variant) => {
        return Array.isArray(variant.options) && variant.options.every((value, index) => value === values[index]);
      });
    }

    function updateVariant() {
      syncColorSwatches();
      const variant = findVariant();

      if (!variant) {
        variantInput.value = '';
        if (submitButton) submitButton.disabled = true;
        if (addLabel) addLabel.textContent = 'Unavailable';
        return;
      }

      variantInput.value = variant.id;

      if (priceNode) {
        const compare = Number(variant.compare_at_price) > Number(variant.price)
          ? `<span>${formatMoney(variant.compare_at_price)}</span>`
          : '';
        priceNode.innerHTML = `${formatMoney(variant.price)}${compare}`;
      }

      if (submitButton) submitButton.disabled = !variant.available;
      if (addLabel) addLabel.textContent = variant.available ? 'Add to cart' : 'Sold out';

      if (variant.featured_media_url) {
        setMainImage(variant.featured_media_url, variant.featured_media_alt || '', variant.featured_media_id);
      }

      try {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      } catch (error) {}
    }

    optionSelects.forEach((select) => select.addEventListener('change', updateVariant));
    updateVariant();
  }

  document.querySelectorAll('[data-product-section]').forEach(initProductSection);

  const sortSelect = document.querySelector('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', () => sortSelect.form && sortSelect.form.submit());
  }

  const inlineSort = document.querySelector('[data-inline-sort]');
  if (inlineSort) {
    inlineSort.addEventListener('change', function () {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }
})();
